import React, { createContext, useContext, useMemo } from 'react'
import { CampaignReviewResult, ReviewTarget } from '../../../generated/graphql'

type ReviewContextType = {
  ngReviewTargets: ReviewTarget[]
  allPendingReviews: boolean
  campaignReviewResults?: readonly CampaignReviewResult[]
}

const ReviewContext = createContext<ReviewContextType>({
  ngReviewTargets: [],
  allPendingReviews: false,
})

type ReviewProviderProps = {
  children: React.ReactNode
  campaignReviewResults?: readonly CampaignReviewResult[]
}

/**
 * 審査状態を管理するコンテキストプロバイダー
 */
export const ReviewProvider: React.FC<ReviewProviderProps> = ({ children, campaignReviewResults }) => {
  // 審査NGの審査項目を抽出
  const ngReviewTargets = useMemo(
    () =>
      campaignReviewResults?.flatMap((result) =>
        result.campaignReviews.filter((review) => !review.isChecked).map((review) => review.reviewTarget),
      ) ?? [],
    [campaignReviewResults],
  )

  // 全ての項目が未審査の場合、trueを返す
  const allPendingReviews = useMemo(
    () => campaignReviewResults?.every((result) => result.campaignReviews.length === 0) ?? false,
    [campaignReviewResults],
  )

  return (
    <ReviewContext.Provider value={{ ngReviewTargets, allPendingReviews, campaignReviewResults }}>
      {children}
    </ReviewContext.Provider>
  )
}

/**
 * 審査状態を取得するためのカスタムフック
 */
export const useReviewContext = (): ReviewContextType => {
  return useContext(ReviewContext)
}
